/* eslint-disable import/prefer-default-export */
import { createAxiosObject } from './_common';

const getParkedCalls = async pageNumber => {
  const axios = createAxiosObject();
  const url = `/parked-calls`;

  const { data } = await axios.get(url, { params: { page: pageNumber } });

  return data;
};

const deleteParkedCalls = async id => {
  const axios = createAxiosObject();
  const url = `/parked-calls/${id}`;

  const { data } = await axios.delete(url);

  return data;
};

export default { getParkedCalls, deleteParkedCalls };
